module.exports = __webpack_public_path__ + "static/media/stackedBar-selected.bca54ea5.svg";